<template>
  <div>
    <label><b>{{ name }}</b></label>
    <div class="options-container">
      <div
        v-for="(option, index) in filteredOptions"
        :key="index"
        class="option"
        :class="{ selected: option.option_selected }"
        @click="selectOption(option)"
      >
        <img :src="option.option_img" :alt="option.option_name">
        <b>{{ option.option_name }}</b>
      </div>
      <input type="hidden" id="selected-option" name="selected-option" :value="internalSelectedValue">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TileOption',
  props: {
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
    slug: {
      type: String,
      required: true,
    },
    selectedValue: {
      type: [String, Number], // Allows both string and number types for selectedValue
      required: false,
    }
  },
  data() {
    return {
      // Initialize internalSelectedValue by checking option_selected first, then falling back to selectedValue
      internalSelectedValue: this.initializeSelectedValue()
    };
  },
 
  watch: {
    // Watch for changes in the selectedValue prop
    selectedValue(newValue) {
      this.internalSelectedValue = newValue;
      this.initializeSelectedValue();  

      const optionn = this.options.find(option => option.option_value == newValue);
      this.$emit('option-selected', { slug: this.slug, optionn });
    }
  },
  computed: {
    filteredOptions() {
      // Filter options to include only those that are active
      return this.options.filter(option => option.option_active);
    }
  },
  methods: {
    initializeSelectedValue() {
      // Find the option that is initially selected based on option_selected
      const initiallySelectedOption = this.options.find(option => option.option_selected === true);
      if (initiallySelectedOption) {
        return initiallySelectedOption.value;
      }
      // Fallback to selectedValue prop if no option_selected is true
      return this.selectedValue || '';
    },
    selectOption(option) {
      // Update internalSelectedValue and emit the selection event
      this.internalSelectedValue = option.option_value;
      this.initializeSelectedValue();  
      this.$emit('option-selected', { slug: this.slug, option });
    }
  }
};
</script>